export const TOOLS_LIST = [
  {
    title: "Minha conta",
    color: "#A900A3",
    background: "#EBDEFD",
    options: [
      {
        permission: "coproducoes",
        route: "tools-coproductions",
        name: "Coproduções",
        icon: "fa-light fa-people-carry-box",
        description: "Compartilhe o produto com seus coprodutores."
      },
      {
        permission: "central-de-colaboradores",
        route: "tools-partners",
        name: "Central de colaboradores",
        icon: "fa-light fa-people-roof",
        description: "Libere permissões de acesso para seus colaboradores."
      }
    ]
  },
  {
    title: "Integrações",
    color: "#009876",
    options: [
      {
        permission: "api-e-notificacoes",
        route: "tools-webhook",
        name: "Webhook (API e notificações)",
        icon: "fa-light fa-network-wired",
        description:
          "Configure suas integrações externas e notificações de vendas com a API da Blitzpay."
      },
      {
        permission: "lead-list",
        route: "tools-leadlist",
        name: "Lead List",
        icon: "fa-light fa-circle-nodes",
        description:
          "Integre seu provedor de email à Blitzpay para organizar seus leads."
      },
      {
        permission: "e-mail-marketing",
        route: "tools-email-marketing",
        name: "E-mail marketing",
        icon: "fa-light fa-at",
        description: "Integre seu provedor de E-mail marketing à Blitzpay."
      },
      {
        permission: "automacoes",
        route: "tools-automations",
        name: "Automações",
        icon: "fa-light fa-arrows-spin",
        description: "Integre suas ferramentas de automação à Blitzpay."
      },
      {
        permission: "notas-fiscais",
        route: "tools-invoices",
        name: "Notas Fiscais",
        icon: "fa-light fa-file-contract",
        description:
          "Integre sua plataforma de emissão de notas fiscais à Blitzpay."
      },
      {
        permission: "kajabi",
        route: "tools-member-area",
        name: "Área de membros",
        icon: "fa-light fa-laptop-file",
        description: "Integre sua plataforma de área de membros à Blitzpay."
      },
      {
        permission: "zoom",
        route: "tools-zoom",
        name: "Zoom",
        icon: "fa-light fa-video",
        description: "Integre sua conta de zoom para aulas ao vivo."
      },
      {
        permission: "certificacoes-mec",
        route: "tools-mec-certifications",
        name: "Certificações MEC",
        icon: "fa-light fa-graduation-cap",
        description: "Integre sua secretaria digital à Blitzpay."
      }
    ]
  },
  {
    title: "Ads e Rastreamento",
    color: "#0693FF",
    options: [
      {
        permission: "pixel-de-rastreamento",
        route: "tools-google-ads",
        name: "Google Ads",
        icon: "fa-brands fa-google",
        description: "Integre sua conta do Google Ads à Blitzpay."
      },
      {
        permission: "pixel-de-rastreamento",
        route: "tools-facebook-ads",
        name: "Facebook Ads",
        icon: "fa-brands fa-facebook",
        description: "Integre sua conta do Facebook Ads à Blitzpay."
      },
      {
        permission: "pixel-de-rastreamento",
        route: "tools-google-analytics",
        name: "Google Analytics",
        icon: "fa-light fa-chart-simple",
        description: "Integre sua conta do Google Analytics à Blitzpay."
      },
      {
        permission: "pixel-de-rastreamento",
        route: "tools-kwai-ads",
        name: "Kwai Ads",
        icon: "fa-light fa-k",
        description: "Integre sua conta do Kwai Ads à Blitzpay."
      }
    ]
  }
];
